import { filter, map, take } from 'rxjs/operators';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import { Injectable } from '@angular/core';
import { getPointOfDeliveryState, OrderBuilderState } from '../../../../../reducers';
import { LoadPointOfDeliverySalesArea } from '../../../actions/point-of-delivery-actions/point-of-delivery.actions';
import { IPointOfDeliveryState } from '../../../reducers/point-of-delivery-reducer/point-of-delivery.reducer';

@Injectable()
export class PointOfDeliveryLoadSalesAreaCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: number): void {
    this.store
      .select(getPointOfDeliveryState)
      .pipe(
        take(1),
        map((state: IPointOfDeliveryState) => {
          return state.pointOfDeliveries.find((pod: IShipmentLocation) => {
            return pod.shipmentLocationId === value;
          });
        }),
        filter(Boolean),
      )
      .subscribe((pod: IShipmentLocation) => this.store.dispatch(new LoadPointOfDeliverySalesArea(pod)));
  }
}
